import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import React from 'react'
import ReactDOM from 'react-dom/client'

import './styles/stylesheets/index.css'
import { LAUNCHDARKLY_CLIENT_ID } from 'constants/app.constants'

import App from './App'
import reportWebVitals from './reportWebVitals'

datadogRum.init({
  applicationId: process.env.REACT_APP_DD_APPLICATION_ID ?? 'NO_APPLICATION_ID',
  clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN ?? 'NO_CLIENT_TOKEN',
  site: 'us5.datadoghq.com',
  service: 'pave-pro',
  env: process.env.REACT_APP_DD_ENV ?? 'development',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: 'mask-user-input',
  plugins: [reactPlugin({ router: true })],
})

Bugsnag.start({
  apiKey: process.env.REACT_APP_BUGSNAG_KEY ?? 'NO_API_KEY',
  plugins: [new BugsnagPluginReact()],
})

const LDProvider = withLDProvider({
  clientSideID: LAUNCHDARKLY_CLIENT_ID,
  timeout: 5,
  options: {
    bootstrap: 'localStorage',
  },
})(App)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <LDProvider />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
